import { Navigate } from 'react-router';

import { useMoreMenuRoutes } from '#/components/Header/useMoreMenuRoutes';
import { useSettingsMenus } from '#/components/Header/useSettingsMenus';
import { Path } from '#/service/routes';

// redirects to the first available more menu page after applying conditions
export const RedirectToDefaultSettings = () => {
  const { settingsToUse } = useSettingsMenus();
  const { moreMenuRoutes } = useMoreMenuRoutes({ settingsToUse });
  const path = (moreMenuRoutes[0] ?? Path.Home) + location.search;

  return <Navigate replace to={path} />;
};
